<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('phone_verification') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="py-12 px-2 text-center">
          <img src="@/assets/images/svg/phone.svg" alt="phone" class="img-mail-verification">
          <h4 class="title font-weight-bold my-5">
            {{ $t('input_verification_code') }}
          </h4>
          <h5 class="subtitle-1 grey--text">
            {{ $t('verification_code_has_been_sent_to_phone') }}
          </h5>
          <h5 class="subtitle-1 grey--text font-weight-bold mb-4">
            {{ data_verification.value.phone }}
          </h5>
          <div class="d-flex justify-center mt-4">
            <CodeInput :loading="false" :fields="5" :auto-focus="true" :field-width="50" :field-height="50" class="input inputVerificationCode" @complete="onCompleteOtp" />
          </div>
          <div class="mt-12">
            <v-btn color="primary" x-large block class="text-none" @click="verify()">
              {{ $t('confirm') }}
            </v-btn>
            <div class="mt-5 text-center">
              <v-progress-circular v-if="resendOtp" :width="3" color="primary" indeterminate />
              <a v-else class="grey--text text-non-direction" @click="resendCode()">{{ $t('resend_code') }}</a>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  validOtp as validOtpCustomer,
  forgotPass as forgotPassCustomer
} from '@/api/auth'
export default {
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      data_verification: {},
      form: {
        phone: '',
        otp_code: ''
      },
      resendOtp: false
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
  },
  methods: {
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    async verify() {
      this.form.phone = this.data_verification.value.phone
      try {
        const { data } = await validOtpCustomer(this.form)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = data.message
        this.$store.dispatch('set_otp_forget_password', this.form.otp_code)
        this.$router.push({ name: 'new_password' }).catch(() => {})
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async resendCode(otp_type = 1) {
      this.resendOtp = true
      let obj = {}
      obj = {
        otp_type: otp_type,
        phone: this.data_verification.value.phone
      }
      try {
        const { data } = await forgotPassCustomer(obj)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = data.message
        const data_verify = this.data_verification
        data_verify.value.expiry_otp = new Date(new Date().getTime() + 2 * 60000)
        this.$store.dispatch('data_verification', data_verify)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.resendOtp = false
    },
    goBack() {
      this.$router.go(-1)
    },
    onCompleteOtp(v) {
      this.form.otp_code = v
    }
  }
}
</script>
